angular.module('randomization')
    .factory('EntityMenuPluginRandomization', ['AccountManager', function(AccountManager) {
        return {
            buildAccess: function(access) {
                access.randomization = AccountManager.hasPermission('access record randomization view');
            },
        };
    }]);
